<template>
  <div class="modal-container clearfix">
    <div class="sel-header clearfix">
      <sale-header ref="saleHeader" @setSaleMan="setSaleMan"></sale-header>
    </div>
    <div class="add-box clearfix" style="margin-top: 10px">
      <vxe-table
        show-overflow
        ref="xTable1"
        class="table-style"
        max-height="400"
        :auto-resize="true"
        :edit-rules="tableRules"
        :data="formData"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="numb" title="合同号">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.numb"
              :disabled="row.id !== ''"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="busType" title="业务类别">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.busType"
              placeholder="请选择"
              :options="bus_Type"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="title" title="订单标题">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.title"
              placeholder="选填"
              @blur="clearTable1V"
              @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="addTime" title="签约日期">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.addTime"
              placeholder="选择日期"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="buyerName" title="托运人名称">
          <template v-slot="{ row }">
            <a
              class="sel-link"
              @click="openBuyer"
              target="_black"
              style="cursor: pointer"
              >{{
                row.buyerName === null || row.buyerName === ""
                  ? "请选择账户"
                  : row.buyerName
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称">
          <template v-slot="{ row }">
            <platform-corp
              :row="row"
              :field="'sellerName'"
              :placeholder="'请选择平台企业'"
            ></platform-corp>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="amountTotal" title="总金额">
          <template v-slot="{ row }">
            <vxe-input v-model="row.amountTotal" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
      </vxe-table>
      <div class="create-order-tabel-header">
        <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="copyEvent"
        ></table-header>
      </div>
      <vxe-table
        show-overflow
        ref="xTable2"
        class="table-style"
        max-height="320"
        :auto-resize="true"
        :data="goodsList"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column
          width="50"
          align="center"
          type="checkbox"
        ></vxe-table-column>

        <vxe-table-column
          width="60"
          align="center"
          type="seq"
          title="序号"
        ></vxe-table-column>
        <vxe-table-column
          width="150"
          field="fileList"
          title="上传附件"
          align="center"
        >
          <template v-slot="{ row }">
            <upload-list
              :row="row"
              :initFileList="row.fileList"
              ref="uploadlistbox"
              :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期" width="130">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.addTime"
              placeholder="选择日期"
              @change="clearTable2V()"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="170">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.goodsName"
              placeholder="选填"
              @blur="clearTable2V"
              @input="$refs.xTable2.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rule" title="规格" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.rule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="包装形式" width="100">
          <template v-slot="{ row }">
            <vxe-input v-model="row.packUnit" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="unit" title="单位" width="55">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.unit"
              placeholder="选填"
              @blur="clearTable2V"
              @input="$refs.xTable2.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="115">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.counts"
              type="number0"
              placeholder="选填"
              v-on:input="countAllAmount($rowIndex)"
              @blur="clearTable2V"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="price" title="单价" width="115">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.price"
              type="number"
              placeholder="选填"
              v-on:input="countAllAmount($rowIndex)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" title="总金额" width="115">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.amount"
              type="number"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="priceType" title="计费方式" width="90">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.priceType"
              placeholder="请选择"
              :options="priceType"
              @change="clearTable2V()"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.isTax"
              placeholder="请选择"
              :options="taxType"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="130">
          <template v-slot="{ row, $rowIndex }">
            <a
              class="sel-link"
              @click="openCarShip({ i: $rowIndex, data: goodsList })"
              target="_black"
              style="cursor: pointer"
              >{{
                row.carShipNum === null || row.carShipNum === ""
                  ? "请选择车船"
                  : row.carShipNum
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100">
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="90">
          <template v-slot="{ row }">
            <vxe-input v-model="row.endPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="120">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginTime"
              placeholder="选择日期"
              @change="clearTable2V()"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="120">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endTime"
              placeholder="选择日期"
              @change="clearTable2V()"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
        show-overflow
        :auto-resize="true"
        class="table-upload-style"
        max-height="160"
        :data="formData"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="attachFile" title="上传附件">
          <template v-slot="{ row }">
            <upload-list
              :isEdit="true"
              :row="row"
              :initFileList="attachFile"
              :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="importGoods()">导入明细</Button>
      <Button @click="reset" v-if="formData[0].id === ''">继续新建</Button>
      <Button
        type="success"
        @click="showVoyagerCharterParty"
        style="width: 150px"
        v-if="formData[0].id === ''"
        >预览合同
      </Button>
      <Button status="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal
      v-model="isShowImportGoods"
      title="导入明细"
      width="600"
      height="300"
      resize
    >
      <div class="import-goods-box clearfix">
        <a class="import-goods-link" @click="impotEvent">
          <Icon type="md-attach" />
          选择导入文件</a
        >
        <a
          class="import-goods-down"
          @click.stop="downloadFile('/file/717合同明细导入表.xls')"
          >下载模板</a
        >
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="buyerVisible"
      title="选择账户"
      width="700"
      height="600"
      @close="closeAccount"
      resize
      position="center"
    >
      <account-modal @choose="chooseBuyer" ref="buyerModel"></account-modal>
    </vxe-modal>
    <vxe-modal
      v-model="carShipVisible"
      title="选择车船"
      width="1300"
      height="600"
      @close="closeCarShip"
      resize
      position="center"
    >
      <choose-car-ship
        ref="carShipModal"
        @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
    <vxe-modal
      v-model="voyagerCharterPartyVisible"
      title="航次租船合同预览"
      width="1300"
      height="700"
      resize
      position="center"
      :fullscreen="true"
    >
      <voyage-charter-party
        ref="voyagerCharterParty"
        @addFile="addFile"
        @close="voyagerCharterPartyVisible = false"
      ></voyage-charter-party>
    </vxe-modal>
  </div>
</template>

<script>
import $C from "@/consts/index";
import AccountModal from "@/components/modal/Account";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import PlatformCorp from "@/components/common/PlatformCorp";
import VoyageCharterParty from "@/views/agreement/VoyageCharterParty";
import UploadList from "@/components/common/UploadList";
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import "viewerjs/dist/viewer.css";
import {
  showLoading,
  hideLoading,
  isEmpty,
  isNotEmpty,
  getExcelTime,
} from "@/utils/util";
import SaleHeader from "@/components/common/SaleHeader"; // 顶部选择框
import TableHeader from "@/components/common/TableHeader";
import XLSX from "xlsx";

const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];
export default {
  components: {
    AccountModal,
    ChooseCarShip,
    PlatformCorp,
    VoyageCharterParty,
    UploadList,
    SaleHeader,
    TableHeader,
  },
  data() {
    return {
      formData: [
        {
          id: "",
          type: 1, //合同性质
          numb: null, // 合同号
          title: null, // 订单标题
          busType: null, // 业务类型
          addWay: 1, //签约方式
          buyerName: null, // 托运人名称
          sellerName: null, // 承运人名称
          salesMan: null,
          salesManId: null,
          salesManager: null,
          salesManagerId: null,
        },
      ],
      attachFile: [],
      goodsList: [
        {
          index: 1,
          fileList: null,
          orderPicUUID: null,
          addTime: null,
          goodsName: null, // 货名
          rule: null, // 规格
          unit: null, // 单位
          counts: null, // 数量
          price: null, // 单价
          amount: null,
          isTax: null, // 是否含税
          carShipNum: null, // 车船号
          beginPlace: null, // 起运地
          endPlace: null, // 到达地
          beginTime: null, // 交货日期
          endTime: null, // 到达时间
          transportationType: null, //运输类型
          priceType: null,
          packUnit: null,
        },
      ], // 商品信息
      tableRules: {
        busType: [{ required: true, message: "请选择业务类型" }],
        buyerName: [{ required: true, message: "请选择托运人" }],
        sellerName: [{ required: true, message: "请选择承运人" }],
      },
      uploadList: [],
      delGoodsIds: [],
      file: null, // 上传
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      bus_Type: [], // 业务类型选择框
      taxType: $C.TAX_TYPE.options, // 是否含税类型选择框
      priceType: $C.PRICE_TYPE.options,
      url: "",
      visible: false,
      buyerVisible: false,
      sellerVisible: false,
      carShipVisible: false,
      voyagerCharterPartyVisible: false,
      dataTmp: {
        index: 1,
        fileList: null,
        orderPicUUID: null,
        addTime: null,
        goodsName: null, // 货名
        rule: null, // 规格
        unit: null, // 单位
        counts: null, // 数量
        price: null, // 单价
        amount: null,
        isTax: null, // 是否含税
        carShipNum: null, // 车船号
        beginPlace: null, // 起运地
        endPlace: null, // 到达地
        beginTime: null, // 交货日期
        endTime: null, // 到达时间
        transportationType: null, //运输类型
        priceType: null,
        packUnit: null,
      },
      isShowImportGoods: false,
    };
  },
  mounted() {
    this.$refs.xTable2.remove();
    this.insertEvent();
    this.getDicContractBusType();
  },
  methods: {
    getDicContractBusType() {
      this.bus_Type = [];
      $api.other.getContractBusTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100,
          },
        })
        .then((res) => {
          res.data.forEach((item) => {
            var obj = {
              label: item.dictText,
              value: parseInt(item.note),
            };
            this.bus_Type.push(obj);
          });
        });
    },
    downloadFile(url) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    importGoods() {
      this.isShowImportGoods = true;
    },
    impotEvent() {
      this.$refs.xTable2
        .readFile({
          types: ["xls", "xlsx"],
        })
        .then((evnt) => {
          this.$Spin.show({
            render: (h) => {
              return h("div", [
                h("Icon", {
                  class: "demo-spin-icon-load",
                  props: {
                    type: "ios-loading",
                    size: 18,
                  },
                }),
                h("div", "导入中..."),
              ]);
            },
          });
          const files = evnt.target.files;
          const fileReader = new FileReader();
          const tableData = [];
          fileReader.onload = (ev) => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const csvData = XLSX.utils.sheet_to_csv(
              Object.values(workbook.Sheets)[0]
            );
            // 解析数据
            // debugger
            csvData.split("\n").forEach((vRow, index) => {
              if (vRow && index > 0) {
                const vCols = vRow.split(",");
                const item = {
                  no: vCols[0],
                  addTime: getExcelTime(vCols[1]),
                  goodsName: vCols[2],
                  rule: vCols[3], // 规格
                  packUnit: vCols[4],
                  unit: vCols[5], // 单位
                  counts: vCols[6], // 数量
                  price: vCols[7], // 单价
                  amount: vCols[8],
                  priceType: vCols[9],
                  isTax: vCols[10], // 是否含税
                  carShipNum: vCols[11], // 车船号
                  transportationType: vCols[12], // 车船号
                  beginPlace: vCols[13], // 起运地
                  endPlace: vCols[14], // 到达地
                  beginTime: getExcelTime(vCols[15]), // 交接受载期
                  endTime: getExcelTime(vCols[16]),
                  fileAddUuidList: [],
                  fileAddUrlList: [],
                  fileUuidList: [],
                };
                if (vCols[12] === "车辆") {
                  item.transportationType = 1;
                  this.formData[0].busType = 2;
                } else if (vCols[12] === "船舶") {
                  item.transportationType = 2;
                  this.formData[0].busType = 1;
                }

                switch (vCols[9]) {
                  case "单价":
                    item.priceType = 1;
                    break;
                  case "包车":
                    item.priceType = 2;
                    break;
                  case "包船":
                    item.priceType = 3;
                    break;
                }
                switch (vCols[10]) {
                  case "是":
                    item.isTax = 1;
                    break;
                  case "否":
                    item.isTax = 0;
                    break;
                }

                tableData.push(item);
              }
            });
            this.goodsList = tableData;
          };
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            this.$Spin.hide();
            this.isShowImportGoods = false;
          }, 1000);
        });
    },
    setSaleMan(data, status) {
      if (status === 1) {
        this.formData[0].salesMan = data.salesMan;
        this.formData[0].salesManId = data.salesManId;
        this.formData[0].salesManager = data.salesManager;
        this.formData[0].salesManagerId = data.salesManagerId;
      } else {
        this.formData[0].salesMan = data.username;
        this.formData[0].salesManId = data.id;
        this.formData[0].salesManager = null;
        this.formData[0].salesManagerId = null;
      }
    },
    countAllAmount(i) {
      let counts = 0;
      let isCounts = true;
      let tableData = this.$refs.xTable2.getTableData().tableData;
      if (
        tableData[i].price === "" ||
        tableData[i].price === null ||
        tableData[i].counts === "" ||
        tableData[i].counts === null
      ) {
        isCounts = false;
      } else {
        let multiply = this.$utils.multiply(
          tableData[i].counts,
          tableData[i].price
        );
        counts = counts + multiply;
        tableData[i].amount = Math.round(counts * 100) / 100;
      }
    },
    closeAccount() {
      this.buyerVisible = false;
      this.$refs.buyerModel.close();
    },
    closeCarShip() {
      this.carShipVisible = false;
      this.$refs.carShipModal.close();
    },
    async commit() {
      if (this.formData[0].salesManId && this.formData[0].salesManId !== "") {
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({ status: "error", message: "校验不通过！" });
          return;
        }
        if (this.formData[0].id === "") {
          this.save();
        } else {
          this.update();
        }
      } else {
        this.$XModal.alert({
          message: "请选择业务员",
          status: "error",
        });
      }
    },
    async save() {
      // if (this.formData[0].addTime !== null) {
      //   this.formData[0].addTime = this.$utils.timestamp(
      //     this.formData[0].addTime
      //   );
      // }
      let isCanNotSubmit = false;
      let tableData = this.$refs.xTable2.getTableData().tableData;
      tableData = tableData.map((i) => {
        let obj = Object.assign(i, {
          addTime: i.addTime ? this.$utils.timestamp(i.addTime) : null,
          beginTime: i.beginTime ? this.$utils.timestamp(i.beginTime) : null,
          endTime: i.endTime ? this.$utils.timestamp(i.endTime) : null,
        });
        return obj;
      });
      isCanNotSubmit = tableData.some((i) => {
        if (i.beginTime > i.endTime) {
          let msg = `第${i.index}行，到达时间不能早于受载/起运时间`;
          this.$XModal.alert({
            message: msg,
            status: "error",
          });
          return true;
        }
      });
      if (isCanNotSubmit) {
        return;
      }
      this.formData[0].compName = this.formData[0].sellerName;
      this.formData[0].goodsList = tableData;
      this.formData[0].attachFile = this.formData[0].fileUuidList;
      showLoading();
      let res = await $api.agreement.request(
        "createContract",
        this.formData[0]
      );
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.close();
        this.$emit("close", "add");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async update() {
      // if (this.formData[0].addTime !== null) {
      //   this.formData[0].addTime = this.$utils.timestamp(
      //     this.formData[0].addTime
      //   );
      // }
      let isCanNotSubmit = false;
      let tableData = this.$refs.xTable2.getTableData().tableData;
      tableData = tableData.map((i) => {
        return Object.assign(i, {
          addTime: i.addTime ? this.$utils.timestamp(i.addTime) : null,
          beginTime: i.beginTime ? this.$utils.timestamp(i.beginTime) : null,
          endTime: i.endTime ? this.$utils.timestamp(i.endTime) : null,
        });
      });
      isCanNotSubmit = tableData.some((i) => {
        if (i.beginTime > i.endTime) {
          let msg = `第${i.index}行，到达时间不能早于受载/起运时间`;
          this.$XModal.alert({
            message: msg,
            status: "error",
          });
          return true;
        }
      });
      if (isCanNotSubmit) {
        return;
      }
      this.formData[0].compName = this.formData[0].sellerName;
      this.formData[0].goodsList = tableData;
      this.formData[0].delGoodsIds = this.delGoodsIds;
      this.formData[0].attachFile = this.formData[0].fileUuidList;
      showLoading();
      let res = await $api.agreement.request(
        "updateContract",
        this.formData[0]
      );
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.close();
        this.$emit("close", "update");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryContractDetail(id) {
      let res = await $api.agreement.request("queryContractDetail", {
        id: id,
      });
      if (res.status === 1) {
        let data = res.data;
        this.formData = [
          {
            id: data.id,
            type: data.type, //合同性质
            numb: data.numb, // 合同号
            title: data.title, // 订单标题
            busType: data.busType, // 业务类型
            addWay: data.addWay, //签约方式
            buyerName: data.buyerName, // 托运人名称
            sellerName: data.sellerName, // 承运人名称
            createUser: data.createUser,
            createTime: data.createTime,
            salesMan: data.salesMan,
            salesManId: data.salesManId,
            salesManager: data.salesManager,
            salesManagerId: data.salesManagerId,
          },
        ];
        this.$refs.saleHeader.setSaleData(data.salesMan, data.salesManager);
        if (data.fileList != null) {
          data.fileList.map((i) => {
            this.formData[0].fileUuidList.push(i.uuid);
            this.uploadList.push(i);
          });
        }
        this.attachFile = data.attachFile;
        this.goodsList = data.goodsList.map((i) => {
          return Object.assign(i, {
            addTime: this.$utils.toDateString(i.addTime, "yyyy-MM-dd"),
            beginTime: this.$utils.toDateString(i.beginTime, "yyyy-MM-dd"),
            endTime: this.$utils.toDateString(i.endTime, "yyyy-MM-dd"),
          });
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async validEvent() {
      let errMap = await this.$refs.xTable1
        .validate()
        .catch((errMap) => errMap);
      if (!errMap) {
        errMap = await this.$refs.xTable2.validate().catch((errMap) => errMap);
      }
      return errMap ? false : true;
    },
    clearTable1V() {
      this.$refs.xTable1.clearValidate();
    },
    clearTable2V() {
      this.$refs.xTable2.clearValidate();
    },
    insertEvent() {
      // 插入货物
      let tableData = this.$refs.xTable2.getTableData().tableData;
      this.$refs.xTable2.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      record.fileList = [];
      record.orderPicUUID = [];
      this.$refs.xTable2.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable2.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      //不能全部删除
      if (
        checkboxRecords.length ==
        this.$refs.xTable2.getTableData().tableData.length
      ) {
        this.$XModal.message({
          message: "不能全部删除,至少保留一条",
        });
        return;
      }

      let confirmRes = await this.$XModal.confirm(
        "删除后不可恢复",
        "是否删除？"
      );
      if (confirmRes == "confirm") {
        this.$refs.xTable2.removeCheckboxRow();
        checkboxRecords.forEach((item) => {
          this.delGoodsIds.push(item.id);
        });
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable2.getCheckboxRecords();
      let copyRow = [];
      checkboxRecords.forEach((item) => {
        let paramsObj = {};
        Object.keys(item).forEach((key) => {
          if (key !== "id") {
            paramsObj[key] = item[key];
          }
        });
        copyRow.push(paramsObj);
      });
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable2.insertAt(copyRow, -1);
    },
    //打开选择弹窗
    openBuyer() {
      this.buyerVisible = true;
      this.$refs.buyerModel.init();
    },
    //选择后回调填入数据
    chooseBuyer(row, type) {
      // this.formData[0].buyerName = type === 1 ? row.compName : row.realName;
      this.formData[0].buyerName = row.userName;
      this.formData[0].buyerInfo = assign(row);
      this.buyerVisible = false;
      this.$refs.buyerModel.close();
    },
    openCarShip(obj) {
      this.info = obj;
      this.carShipVisible = true;
      this.$refs.carShipModal.init();
    },
    chooseCarShip(row, type) {
      let data = this.$refs.xTable2.getTableData().tableData;
      let i = this.info.i;
      if (type === "ship") {
        data[i].carShipNum = row.shipName;
        data[i].transportationType = 2;
      } else {
        data[i].carShipNum = row.carNum;
        data[i].transportationType = 1;
      }
      this.$refs.carShipModal.close();
      this.carShipVisible = false;
    },
    close() {
      this.formData = [
        {
          id: "",
          type: 1, //合同性质
          numb: null, // 合同号
          title: null, // 订单标题
          busType: null, // 业务类型
          addWay: 1, //签约方式
          buyerName: null, // 托运人名称
          sellerName: null, // 承运人名称
          salesMan: null,
          salesManId: null,
          salesManager: null,
          salesManagerId: null,
        },
      ];
      this.goodsList = [
        {
          index: 1,
          fileList: [],
          orderPicUUID: null,
          addTime: null,
          goodsName: null, // 货名
          rule: null, // 规格
          unit: null, // 单位
          counts: null, // 数量
          price: null, // 单价
          amount: null,
          isTax: null, // 是否含税
          carShipNum: null, // 车船号
          endTime: null, // 到达时间
          beginPlace: null, // 起运地
          endPlace: null, // 到达地
          beginTime: null, // 交货日期
          transportationType: null, //运输类型.
          priceType: null,
          packUnit: null,
        },
      ];

      this.uploadList = [];
      this.delGoodsIds = [];
      this.clearTable1V();
      this.clearTable2V();
      this.$refs.saleHeader.setSaleData(null, null);
    },
    showVoyagerCharterParty() {
      let formData = this.formData[0];
      if (
        empties.includes(formData.buyerName) ||
        empties.includes(formData.sellerName)
      ) {
        this.$XModal.message("请先完善购买方和承运人信息");
      } else {
        let goodsData = this.$refs.xTable2.getTableData().tableData[0];
        this.voyagerCharterPartyVisible = true;
        this.$refs.voyagerCharterParty.init("Buyer", formData, goodsData);
      }
    },
    addFile(file) {
      this.formData[0].fileUuidList.push(file.uuid);
      this.uploadList.push(file);
    },
    async reset() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({ status: "error", message: "校验不通过！" });
        return;
      }
      // if (this.formData[0].addTime !== null) {
      //   this.formData[0].addTime = this.$utils.timestamp(
      //     this.formData[0].addTime
      //   );
      // }
      this.formData[0].compName = this.formData[0].sellerName;
      this.formData[0].goodsList = this.goodsList;
      let res = await $api.agreement.request(
        "createContract",
        this.formData[0]
      );
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.close();
        this.$emit("close", "reset");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  },
};
</script>

<style>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>